import { useCallback, useState } from "react";
import PromptDialog from "@entrilia/shared/components/dialog/PromptDialog";
import { defined } from "@entrilia/shared/utilities/typeHelper";
import type { ReportGroup } from "../../../../../../api/types/svTypes.ts";
import useClientContext from "../../../../../../context/useClientContext";
import { useGroupsContext } from "../contexts/GroupsContext.ts";
import ReportGroupForm from "./ReportGroupForm.tsx";

interface Props {
  group: ReportGroup;
  onChanged: () => void;
  onClose: () => void;
}

export const RenameGroupDialog = (props: Props) => {
  const { group, onChanged, onClose } = props;

  const { clientCode } = useClientContext();
  const { actions, groups: reportGroups } = useGroupsContext();

  const [error, setError] = useState<string>();
  const [saving, setSaving] = useState(false);
  const groups = defined(reportGroups[clientCode]);

  const onSave = useCallback(
    (caption: string) => {
      setSaving(true);
      let maxOrder = 0;
      groups.forEach((rg) => {
        maxOrder = Math.max(maxOrder, rg.order);
      });
      const groupToSave = { ...group, caption } as ReportGroup;
      actions
        .update(clientCode, groupToSave)
        .then(() => {
          onChanged();
          onClose();
        })
        .catch(() => {
          setError("An error occurred while renaming the group.");
          setSaving(false);
        });
    },

    [groups, group, actions, clientCode, onChanged, onClose]
  );

  return (
    <PromptDialog open={true} sx={{ minHeight: "auto" }}>
      <ReportGroupForm
        group={group}
        title="Rename Group"
        groups={groups}
        saving={saving}
        onCancel={onClose}
        error={error}
        onSave={onSave}
      />
    </PromptDialog>
  );
};

export default RenameGroupDialog;
